/**
 * CMS v2 components expect color_primary / color_secondary keys.
 * Homerun dev seeds may only have legacy keys (color_actions, color_links, …).
 */
export function getBrandThemeColors(brandInfo) {
  const c = brandInfo?.colors || {};
  return {
    ...c,
    color_primary: c.color_primary || c.color_actions || c.color_links || '#067bc2',
    color_primary_text: c.color_primary_text || '#ffffff',
    color_secondary: c.color_secondary || c.color_highlight || '#7940ff',
    color_secondary_text: c.color_secondary_text || '#ffffff',
    color_decorative_icon: c.color_decorative_icon || c.color_actions || '#000000'
  };
}

const DEFAULT_CLOUDFRONT_URL = 'https://d30lxkk358dph1.cloudfront.net';

function isUsableLogoUrl(url) {
  if (!url || typeof url !== 'string') return false;
  // Rails returns a CloudFront path with empty segments when logo_image is null.
  if (/\/brand_info\/logo_image\/\//.test(url) || /\/logo_image\/\/$/.test(url)) {
    return false;
  }
  return url.length > 0;
}

/**
 * When CLOUDFRONT_URL env var is unset on the server, logo URLs arrive as
 * relative paths (e.g. "/production/tenant/…"). Prepend the CloudFront
 * domain so the browser can resolve them.
 */
function ensureAbsoluteUrl(url) {
  if (!url || typeof url !== 'string') return url;
  if (/^https?:\/\//.test(url)) return url;
  if (url.startsWith('/')) return DEFAULT_CLOUDFRONT_URL + url;
  return url;
}

export function getBrandLogoUrl(brand) {
  if (!brand) return null;
  const fromTop = brand.logo_image;
  if (isUsableLogoUrl(fromTop)) return ensureAbsoluteUrl(fromTop);
  const fromInfo = brand.brand_info?.logo_image;
  if (isUsableLogoUrl(fromInfo)) return ensureAbsoluteUrl(fromInfo);
  if (fromInfo?.url && isUsableLogoUrl(fromInfo.url))
    return ensureAbsoluteUrl(fromInfo.url);
  return null;
}

export function getBrandLogoWhiteUrl(brand) {
  if (!brand) return null;
  const fromTop = brand.logo_white_image;
  if (isUsableLogoUrl(fromTop)) return ensureAbsoluteUrl(fromTop);
  const fromInfo = brand.brand_info?.logo_white_image;
  if (isUsableLogoUrl(fromInfo)) return ensureAbsoluteUrl(fromInfo);
  if (fromInfo?.url && isUsableLogoUrl(fromInfo.url))
    return ensureAbsoluteUrl(fromInfo.url);
  return null;
}
